import FooterSection from "assets/Footer";
import Navbar from "../assets/Navbar";
import CardDesign from "../components/cardDesign";
import useAllFreeDeliveryProducts from "hook/useAllFreeDeliveryProducts";
import { useState, useEffect } from "react";
import ShimmerFreeDelivery from "components/shimmer/ShimmerFreeDelivery";
import RevealOnScroll from "components/RevealOnScroll";
import { FaTag, FaTruck } from "react-icons/fa";
import ScrollToTopButton from "components/ScrollToTopButton";
const FreeDeliveryFullPage = () => {
  const { allFreeDeliveryProducts, loading1, error } =
    useAllFreeDeliveryProducts();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (loading1) {
    return <ShimmerFreeDelivery />;
  }
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="mx-auto w-full mb-4">
        <div className="">
          {/* ✅ Data */}
          {!loading1 && !error && allFreeDeliveryProducts.length === 0 && (
            <div className="text-center py-10">
              <div className="text-5xl mb-3">📦</div>
              <h3 className="text-lg font-semibold text-slate-700">
                কোনো পণ্য পাওয়া যায়নি
              </h3>
              <p className="text-sm text-slate-500 mt-1">
                পরে আবার চেষ্টা করুন অথবা অন্য ক্যাটাগরি দেখুন
              </p>
            </div>
          )}
          {!loading1 && !error && allFreeDeliveryProducts.length > 0 && (
            <>
              <RevealOnScroll>
                <section className="overflow-hidden sm:mb-8 mb-5 bg-slate-900 text-white shadow-lg">
                  <div className="relative">
                    <div className="absolute inset-0">
                      <img
                        src="https://images.unsplash.com/photo-1607083206968-13611e3d76db?auto=format&fit=crop&w=1400&q=80"
                        alt="Free delivery banner"
                        className="h-full w-full object-cover opacity-25"
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/95 via-slate-900/85 to-cyan-900/70" />
                    </div>
                    <div className="relative p-5 sm:px-10">
                      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                        <div>
                          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-100">
                            <FaTruck />
                            Zero Shipping Cost
                          </p>
                          <h1 className="mt-2 text-2xl font-extrabold sm:text-3xl">
                            Free Delivery Products
                          </h1>
                          <p className="mt-2 max-w-xl text-sm text-slate-200 sm:text-base">
                            Every item on this page comes with free delivery —
                            no extra shipping fees at checkout.
                          </p>
                        </div>
                        <div className=" flex flex-wrap items-center gap-2 text-xs font-semibold text-slate-200">
                          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                            <FaTruck />
                            Always free delivery
                          </span>
                          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                            <FaTag />
                            Discount included
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </RevealOnScroll>
              <CardDesign likeData={allFreeDeliveryProducts} />
            </>
          )}
        </div>
      </main>
      <FooterSection />
      {showScrollTop && <ScrollToTopButton />}
    </div>
  );
};

export default FreeDeliveryFullPage;
